import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar.js";
import Snackbar from "../../../common/Snackbar.js";
import { moveStep } from "../../../redux/stepSlice.js";
import { copyElement } from "../../../redux/sectionSlice.js";
import { generateSHA256 } from "../../../util/generateSHA256.js";
import { getPages, renderPreview, renderVideo } from "../plugins/utils.js";
import {
  applyTransparency,
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import { generateConfirmMoveMessage } from "../../SubassemblyDetails/utils/movePreviewUtils.js";
import {
  generateSourceTreePath,
  generateTargetTreePath,
  getDisplayIndex,
  getSubstepLetter,
  generateStatusText,
  validateAndCorrectTreePathData,
  generateCompleteTreePath,
  HeadingWithTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils.js";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import {
  extractVersionStructure,
  getAuditTrailData,
  prepareNewContent,
} from "../../../util/getAuditTrailData.js";
import { getRevAllNodes } from "../../../redux/procedureRevisionSlice.js";
import { getMoveCopyText } from "../../../util/AppUtils.js";
import {
  insertItemRelativeToTarget,
  insertItemPreservingOrder,
  calculateSiblingOrder,
} from "./ProcedureMoveUtils.js";
const ProcedureVideoMovePreview = () => {
  const { sections } = useSelector((state) => state.section);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;

  // Helper function to log container contents for debugging
  const logContainerContents = (containerId, items, label) => {
    items.forEach((item, idx) => {
    });
  };

  let substepCounter = 1;
  let stepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const [selectedView, setSelectedView] = useState("new");

  // Handle view mode change
  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    sourceStepIndex,
    steps,
    targetStepIndex = 0, // Default value if not provided
    targetNodeIndex, // Add this missing variable
    partId,
    revisionId,
    fromStepId,
    fromSubstepTreeId,
    fromSubstepSiblingOrder,
    targetSectionData,
    fromSectionId,
    fromSubstepId,
    targetNodeType,
    elementId,
    fromProcedureTreeRef,
    createCopy = false,
  } = location.state;
  const [previewSections, setPreviewSections] = useState([...sections]);
  const sortedSections = [...sections];

  const { allRevisionNodes } = useSelector((state) => state.procedureRevision);
  useEffect(() => {
    if (elementId) {
      dispatch(
        getRevAllNodes({
          partId: partId,
          revisionId: revisionId,
        })
      );
    }
  }, [dispatch, elementId, partId, revisionId]);
  // Ensure we have sourceStepId available
  useEffect(() => {
    // Make sure we have a valid sourceStepId
    if (
      location.state.movingNode &&
      !location.state.sourceStepId &&
      sourceStepIndex !== undefined
    ) {
      const sourceSectionId =
        sortedSections[sourceSectionIndex]?.section_tree_node_id;
      const sourceSteps = stepsBySection[sourceSectionId] || [];
      const sourceStep = sourceSteps[sourceStepIndex] || {};

      if (sourceStep.step_tree_node_id) {
        location.state.sourceStepId = sourceStep.step_tree_node_id;
      } else if (steps && steps.length > 0) {
        location.state.sourceStepId = steps[0].step_tree_node_id;
      }
    }
  }, [
    sourceStepIndex,
    sourceSectionIndex,
    stepsBySection,
    sortedSections,
    steps,
    location.state,
  ]);

  useEffect(() => {
    // Create preview of the move
    const newSections = [...sections];


    if (location.state.movingNode) {
      // Parse the step number and video number from the title
      let sourceStepNumber = null;
      let sourceVideoNumber = null;


      // Check if we have the title and extract numbers
      if (location.state.title) {
        // Handle both patterns: "Video X from Step Y" and potential "NaN" cases
        const titleMatch = location.state.title.match(
          /Video\s+(\d+)\s+from\s+Step\s+([0-9]+|NaN)/i
        );
        if (titleMatch) {
          sourceVideoNumber = parseInt(titleMatch[1], 10);
          // Only parse the step number if it's not "NaN"
          if (titleMatch[2] !== "NaN") {
            sourceStepNumber = parseInt(titleMatch[2], 10);
          }
        }
      }

      // Look for step number in various locations
      if (!sourceStepNumber || isNaN(sourceStepNumber)) {
        // Try location.state.stepNumber
        if (
          location.state.stepNumber &&
          !isNaN(parseInt(location.state.stepNumber, 10))
        ) {
          sourceStepNumber = parseInt(location.state.stepNumber, 10);
        }
        // Try location.state.data.stepNumber
        else if (
          location.state.data &&
          location.state.data.stepNumber &&
          !isNaN(parseInt(location.state.data.stepNumber, 10))
        ) {
          sourceStepNumber = parseInt(location.state.data.stepNumber, 10);
        }
        // Try sourceStepIndex + 1 if available and valid
        else if (sourceStepIndex !== undefined && !isNaN(sourceStepIndex)) {
          sourceStepNumber = sourceStepIndex + 1;
        }
        // Last resort: check for sourceStepId and find matching step
        else if (location.state.sourceStepId) {
          // Loop through all steps to find the one with matching ID
          let globalStepCounter = 0;
          for (const sectionId in stepsBySection) {
            const steps = stepsBySection[sectionId] || [];
            for (const step of steps) {
              globalStepCounter++;
              if (step.step_tree_node_id === location.state.sourceStepId) {
                sourceStepNumber = globalStepCounter;
                break;
              }
            }
            if (sourceStepNumber) break;
          }
        }
      }

      // Similarly, ensure we have valid video number
      if (!sourceVideoNumber || isNaN(sourceVideoNumber)) {
        if (
          location.state.videoNumber &&
          !isNaN(parseInt(location.state.videoNumber, 10))
        ) {
          sourceVideoNumber = parseInt(location.state.videoNumber, 10);
        } else if (
          location.state.sourceNodeIndex !== undefined &&
          !isNaN(location.state.sourceNodeIndex)
        ) {
          sourceVideoNumber = location.state.sourceNodeIndex + 1;
        } else {
          sourceVideoNumber = 1; // Default to first video
        }
      }

      // Store these values back in location.state for later use
      location.state.sourceStepNumber = sourceStepNumber;
      location.state.sourceVideoNumber = sourceVideoNumber;


      // Use derived source step number/index for display, with meaningful fallback
      const displaySourceStepNumber = sourceStepNumber || "current"; // If we can't determine step number, use "current" instead of NaN

      // Use derived source video number for display
      const displaySourceVideoNumber =
        sourceVideoNumber ||
        (isNaN(location.state.sourceNodeIndex)
          ? 1
          : location.state.sourceNodeIndex + 1);
    }

    setPreviewSections(newSections);
  }, [
    sections,
    moveType,
    sourceStepIndex,
    targetSectionIndex,
    location.state,
    stepsBySection,
  ]);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const handleConfirmSave = async () => {
    if (!comment.trim()) {
      showSnackbar("Please enter a comment before confirming.", "error");
      return;
    }

    setIsModalLoading(true);
    try {
      const targetContainerId =
        targetSectionData?.substepId || targetSectionData?.stepId;


      let parent_version = Object.values(videos)
        .flat()
        .find((a) => a.video_tree_node_ref === elementId);

      const newContent = prepareNewContent({
        allRevisionNodes,
        fromInfo: {
          fromSectionId,
          fromStepId,
          fromSubstepId,
          nodeId: elementId,
        },
        toInfo: { ...targetSectionData },
        moveType,
        node_id_key: "video_tree_node_id",
      });

      const audit_trail_data = await getAuditTrailData(
        {
          action: createCopy ? "VIDEO_COPIED" : "VIDEO_MOVED",
          comment: comment,
          parent_version: parent_version ? parent_version.version_id_ref : null,
          version_content: {
            action_to_show: getMoveCopyText(
              location.state.move_rev_node_info,
              partNumber,
              revision
            ),
            originingalContent: extractVersionStructure(allRevisionNodes),
            newContent: newContent,
            rev: revision,
            status: location.state.status,
            type,
            item_code_type: type,
            partNumber,
          },
        },
        false
      );

      // Prepare payload for moving video
      const stepData = {
        from_procedure_tree_node_ref: fromProcedureTreeRef,
        from_order: parseInt(fromSubstepSiblingOrder),
        from_type: "video",
        from_part_id_ref: partId,
        from_procedure_rev_ref: revisionId,
        from_section_id_ref: fromSectionId,
        from_step_id_ref: fromStepId,
        from_substep_id_ref: fromSubstepId === "null" ? null : fromSubstepId,
        to_procedure_tree_node_ref: targetSectionData?.elementTreeId,
        to_order: (() => {
          // For "into" moves, this will be calculated later
          if (moveType === "into") {
            return 0; // Placeholder, will be calculated below
          }

          // CRITICAL FIX: Use the expectedSiblingOrder that was calculated in the move function
          // This ensures the save logic matches exactly what the preview shows
          if (location.state.expectedSiblingOrder !== undefined) {
            return location.state.expectedSiblingOrder;
          }

          // Fallback: use the base order calculation if expectedSiblingOrder is not available
          const baseOrder = parseInt(
            targetSectionData?.elementSiblingOrder ||
              targetSectionData?.substepSiblingOrder ||
              targetSectionData?.stepSiblingOrder ||
              1
          );

          // Check if we're moving within the same step/substep (same parent)
          const isSameParent = fromStepId === targetSectionData?.stepId;

          if (moveType === "up") {
            // Move above: same step = baseOrder - 1, different step = baseOrder
            return isSameParent ? Math.max(1, baseOrder - 1) : baseOrder;
          } else if (moveType === "below") {
            // Move below: same step = baseOrder, different step = baseOrder + 1
            return isSameParent ? baseOrder : baseOrder + 1;
          }

          return baseOrder;
        })(),
        to_type: "video", // Always use the source item type (video), not the target type
        to_part_id_ref: partId,
        to_procedure_rev_ref: revisionId,
        to_section_id_ref: targetSectionData?.sectionId,
        to_step_id_ref: targetSectionData?.stepId,
        to_substep_id_ref: targetSectionData?.substepId,
        from_child_node_ref: location.state.elementId,
        to_child_node_ref: targetSectionData?.elementId,
        direction_move_into: Boolean(
          moveType === "into" ||
            fromStepId !== targetSectionData?.stepId ||
            (fromSubstepId &&
              targetSectionData?.substepId &&
              fromSubstepId !== targetSectionData?.substepId)
        ),
        direction:
          moveType === "up"
            ? createCopy
              ? "paste_up"
              : "move_up"
            : moveType === "below"
            ? createCopy
              ? "paste_down"
              : "move_down"
            : createCopy
            ? "paste_down"
            : "move_down",
        ...(createCopy ? {} : { create_copy: createCopy }), // Only add create_copy for move operations
        audit_trail_data,
      };

      if (moveType === "into") {
        // For moving into, we need to calculate the highest sibling_order in the target container
        // and set to_order to (highest + 1) to place the rich text at the end

        // Get all items in the target container
        let targetItems = [];

        if (targetSectionData?.substepId) {
          // If target is a substep, get all items in that substep
          targetItems = [
            ...(richTexts[targetContainerId] || []),
            ...(forms[targetContainerId] || []),
            ...(attachments[targetContainerId] || []),
            ...(canvases[targetContainerId] || []),
            ...(videos[targetContainerId] || []),
          ];
        } else if (targetSectionData?.stepId) {
          // If target is a step, get all items in that step (excluding substep items)
          const allStepItems = [
            ...(richTexts[targetContainerId] || []),
            ...(forms[targetContainerId] || []),
            ...(attachments[targetContainerId] || []),
            ...(canvases[targetContainerId] || []),
            ...(videos[targetContainerId] || []),
          ];

          // Filter out items that belong to substeps
          targetItems = allStepItems.filter(
            (item) => !item.substep_id_ref && !item.sub_step_tree_node_id
          );
        }

        // Find the highest sibling_order in the target items
        let highestOrder = 0;
        targetItems.forEach((item) => {
          const order = parseInt(
            item.sibling_order || item.procedure_tree?.sibling_order || 0
          );
          if (!isNaN(order) && order > highestOrder) {
            highestOrder = order;
          }
        });

        // Set to_order to highest + 1 (or at least 1 if no items)
        stepData.to_order = Math.max(1, highestOrder + 1);
      }

      // Clean up empty or null substep ref
      if (
        !stepData.from_substep_id_ref ||
        stepData.from_substep_id_ref === "null"
      ) {
        delete stepData.from_substep_id_ref;
      }

      // Clean up empty or null target substep ref
      if (
        !stepData.to_substep_id_ref ||
        stepData.to_substep_id_ref === "null"
      ) {
        delete stepData.to_substep_id_ref;
      }

      // Debug logging to troubleshoot the payload issue

      // Call API to update the video position
      if (createCopy) {
        // Use copyElement action for copy operations
        await dispatch(copyElement(stepData)).unwrap();
      } else {
        // Use moveStep action for move operations
        await dispatch(moveStep(stepData)).unwrap();
      }

      showSnackbar(
        createCopy ? "Video copied successfully!" : "Video moved successfully!",
        "success"
      );

      setModalOpen(false);
      navigate(-3); // Navigate back to the previous page
    } catch (error) {
      console.error("Error during move operation:", error);
      showSnackbar("Error during move operation: " + error.message, "error");
    } finally {
      setIsModalLoading(false);
    }
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const getReorderedStepsBySection = (
    stepsBySection,
    sortedSections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    targetStepIndex,
    moveType,
    movingStep = false
  ) => {
    if (selectedView === "original") return stepsBySection;

    // Clone the existing structure to avoid mutating state directly
    const updatedStepsBySection = JSON.parse(JSON.stringify(stepsBySection));

    if (movingStep) {
      // Get the source section ID
      const sourceSectionId = sortedSections.find(
        (s) => s.section_tree_node_id === sourceSectionIndex
      )?.section_tree_node_id;
      if (!sourceSectionId) return updatedStepsBySection;

      // Get the target section ID
      const targetSectionId =
        sortedSections[targetSectionIndex].section_tree_node_id;

      // Get the source steps array and the step to move
      const sourceSteps = [...(updatedStepsBySection[sourceSectionId] || [])];
      if (sourceStepIndex >= sourceSteps.length) return updatedStepsBySection;

      // Remove step from source
      const [movedStep] = sourceSteps.splice(sourceStepIndex, 1);

      // Get the target steps array
      const targetSteps = [...(updatedStepsBySection[targetSectionId] || [])];

      // Handle different move types
      if (moveType === "into") {
        // Move to end of target section
        targetSteps.push(movedStep);
      } else if (moveType === "up") {
        // Insert before the target step
        targetSteps.splice(targetStepIndex, 0, movedStep);
      } else if (moveType === "below") {
        // Insert after the target step
        targetSteps.splice(targetStepIndex + 1, 0, movedStep);
      }

      // Update the mappings
      updatedStepsBySection[sourceSectionId] = sourceSteps;
      updatedStepsBySection[targetSectionId] = targetSteps;

      return updatedStepsBySection;
    } else {
      // Original section moving logic - just return the original for now
      // as we're only focusing on step movement
      const newStepsBySection = { ...stepsBySection };
      return newStepsBySection;
    }
  };

  const updated = getReorderedStepsBySection(
    stepsBySection,
    sections,
    sourceSectionIndex,
    targetSectionIndex,
    sourceStepIndex,
    location.state.targetStepIndex,
    moveType,
    location.state.movingStep
  );

  const updatedSubstepsByStep = substepsByStep;

  // Set up the preview data for the UI
  const updatedSteps = location.state.movingStep
    ? getReorderedStepsBySection(
        stepsBySection,
        sections,
        sourceSectionIndex,
        targetSectionIndex,
        sourceStepIndex,
        location.state.targetStepIndex,
        moveType,
        location.state.movingStep
      )
    : stepsBySection;

  const getReorganizedContentItems = (
    allContentItems, // { stepId or substepId: array of items }
    sourceStepId,
    targetStepId,
    sourceNodeIndex,
    targetNodeIndex,
    moveType,
    nodeType // "richText", "form", "attachment", etc.
  ) => {

    // Log additional state information for debugging

    // Add defensive checks for null/undefined values
    if (sourceNodeIndex === null || sourceNodeIndex === undefined) {
      sourceNodeIndex = 0;
    }

    if (targetNodeIndex === null || targetNodeIndex === undefined) {
      targetNodeIndex = 0;
    }

    if (selectedView === "original" || !location.state.movingNode) {
      return allContentItems;
    }

    // Initialize tracking variables for target detection
    let richTextTargetFound = false;
    let canvasTargetFound = false;


    // Normalize nodeType for consistent comparison
    const normalizedNodeType = nodeType === "rich_text" ? "richText" : nodeType;

    // If sourceStepId is missing, try to derive it
    if (!sourceStepId && sourceStepIndex !== undefined) {
      const sourceSectionId =
        sortedSections[sourceSectionIndex]?.section_tree_node_id;
      const sourceSteps = stepsBySection[sourceSectionId] || [];
      const sourceStep = sourceSteps[sourceStepIndex] || {};
      sourceStepId = sourceStep.step_tree_node_id;
    }

    // If we still don't have sourceStepId, check if we're moving to the same step (from a substep)
    if (!sourceStepId && targetStepId) {
      sourceStepId = targetStepId;
    }

    // If sourceStepId is still missing but we have steps from location.state
    if (!sourceStepId && steps && steps.length > 0) {
      sourceStepId = steps[0].step_tree_node_id;
    }

    if (!sourceStepId || !targetStepId) {
      console.error(
        "Source or target step ID is still missing after fallbacks"
      );
      console.error("source section index:", sourceSectionIndex);
      console.error("source step index:", sourceStepIndex);
      return allContentItems; // Return original items without changes
    }

    const updatedItems = JSON.parse(JSON.stringify(allContentItems));

    // Initialize main targetItems variable that will be used throughout the function
    let targetItems = null;

    // Initialize main insertIndex variable that will be used throughout the function
    let insertIndex = 0; // Default to beginning of list

    // Get source container ID (either substep ID or step ID)
    let sourceContainerId = null;
    if (location.state.sourceSubstepIndex !== undefined) {
      // For substep source
      const substeps = substepsByStep[sourceStepId] || [];
      const sourceSubstep = substeps[location.state.sourceSubstepIndex];
      sourceContainerId = sourceSubstep?.sub_step_tree_node_id;
    } else {
      // For step source
      sourceContainerId = sourceStepId;
    }

    // Get target container ID (either substep ID or step ID)
    let targetContainerId = null;

    const isTargetSubstep =
      targetStepId && location.state.targetSubstepIndex !== undefined;
    if (isTargetSubstep) {
      // For substep target
      const substeps = substepsByStep[targetStepId] || [];
      const targetSubstep = substeps[location.state.targetSubstepIndex];
      targetContainerId = targetSubstep?.sub_step_tree_node_id;
    } else {
      // For step target
      targetContainerId = targetStepId;
    }


    // If we're missing a source container but have a target, handle specially
    if (!sourceContainerId && targetContainerId) {

      // For "into" moves, we don't need positioning logic - just add to end
      if (moveType === "into") {

        // Create a placeholder item based on the node type
        const placeholderItem = {
          type: normalizedNodeType,
          short_description: `Video ${sourceNodeIndex + 1} from Step ${
            sourceStepIndex + 1
          } (placeholder)`,
          isMovedItem: true, // Add flag for visual highlighting
        };

        // Add type-specific properties
        if (normalizedNodeType === "richText") {
          placeholderItem.rich_text_node_id = `temp-richtext-${Date.now()}`;
          placeholderItem.rich_text_content = "<p>Moved content</p>";
          placeholderItem.category_data = { category_name: "" };
        } else if (normalizedNodeType === "attachment") {
          placeholderItem.attachment_tree_node_id = `temp-attachment-${Date.now()}`;
          placeholderItem.attachments = [];
        } else if (normalizedNodeType === "form") {
          placeholderItem.form_tree_node_id = `temp-form-${Date.now()}`;
        } else if (normalizedNodeType === "canvas") {
          placeholderItem.canvas_tree_node_id = `temp-canvas-${Date.now()}`;
          placeholderItem.shapes = [];
        } else if (normalizedNodeType === "video") {
          placeholderItem.video_tree_node_id = `temp-video-${Date.now()}`;
          placeholderItem.video = "";
          placeholderItem.video_url = "";
        }

        // Add to target container
        targetItems = updatedItems[targetContainerId] || [];

        // CRITICAL FIX: Sort targetItems by sibling_order to ensure correct positioning
        targetItems.sort((a, b) => {
          if (!a || !b) return 0;
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;
          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;
          // Fallback: compare created_at
          const dateA = a.created_at ? new Date(a.created_at) : null;
          const dateB = b.created_at ? new Date(b.created_at) : null;
          if (dateA && dateB) return dateB - dateA;
          return 0;
        });

        // CRITICAL DEBUG: Show sorted order after sorting
        targetItems.forEach((item, idx) => {
        });

        targetItems.push(placeholderItem);
        updatedItems[targetContainerId] = targetItems;

        return updatedItems;
      }

      // Create a placeholder item based on the node type
      const placeholderItem = {
        type: normalizedNodeType,
        short_description: `Video ${sourceNodeIndex + 1} from Step ${
          sourceStepIndex + 1
        } (placeholder)`,
        isMovedItem: true, // Add flag for visual highlighting
      };

      // Add type-specific properties
      if (normalizedNodeType === "richText") {
        placeholderItem.rich_text_node_id = `temp-richtext-${Date.now()}`;
        placeholderItem.rich_text_content = "<p>Moved content</p>";
        placeholderItem.category_data = { category_name: "" };
      } else if (normalizedNodeType === "attachment") {
        placeholderItem.attachment_tree_node_id = `temp-attachment-${Date.now()}`;
        placeholderItem.attachments = [];
      } else if (normalizedNodeType === "form") {
        placeholderItem.form_tree_node_id = `temp-form-${Date.now()}`;
      } else if (normalizedNodeType === "canvas") {
        placeholderItem.canvas_tree_node_id = `temp-canvas-${Date.now()}`;
        placeholderItem.shapes = [];
      } else if (normalizedNodeType === "video") {
        placeholderItem.video_tree_node_id = `temp-video-${Date.now()}`;
        placeholderItem.video = "";
        placeholderItem.video_url = "";
      }

      // Add to target based on move type
      targetItems = updatedItems[targetContainerId] || [];

      // CRITICAL FIX: Sort targetItems by sibling_order to ensure correct positioning
      targetItems.sort((a, b) => {
        if (!a || !b) return 0;
        const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
        const orderB = b.sibling_order || b.procedure_tree?.sibling_order;
        const orderCompare = compareSiblingOrders(orderA, orderB);
        if (orderCompare !== 0) return orderCompare;
        // Fallback: compare created_at
        const dateA = a.created_at ? new Date(a.created_at) : null;
        const dateB = b.created_at ? new Date(b.created_at) : null;
        if (dateA && dateB) return dateB - dateA;
        return 0;
      });

      // CRITICAL DEBUG: Show sorted order after sorting
      targetItems.forEach((item, idx) => {
      });

      if (moveType === "into") {
        // For "into" moves, just add to the end
        targetItems.push(placeholderItem);
      } else {
        // For "up" or "below" moves, we need to insert at the correct position

        // When moving above/below, we need to consider ALL items in the container, not just items of the same type
        // This is because we want to position relative to the target item regardless of its type
        const visibleTargetItems = targetItems.filter((item) => {
          if (!item) return false; // Skip null/undefined items

          // Match container (step or substep)
          const containerMatches = isTargetSubstep
            ? item.sub_step_tree_node_id === targetContainerId
            : !item.substep_id_ref && !item.sub_step_tree_node_id;

          return containerMatches;
        });


        insertIndex = targetItems.length; // Default to end of list

        // If we have a target node index and enough items
        if (
          targetNodeIndex !== undefined &&
          targetNodeIndex < visibleTargetItems.length
        ) {
          const targetItem = visibleTargetItems[targetNodeIndex];

          const targetItemIndex = targetItems.indexOf(targetItem);

          if (targetItemIndex !== -1) {
            // Insert before (up) or after (below) the target
            if (moveType === "up") {
              insertIndex = targetItemIndex;
            } else if (moveType === "below") {
              insertIndex = targetItemIndex + 1;
            }
          }
        } else {
          // Handle out of bounds target

          // Try using global node number if available
          const targetGlobalNumber = location.state.targetNodeGlobalNumber;
          if (targetGlobalNumber && visibleTargetItems.length > 0) {

            // Find by global number or use first item as fallback
            const firstItem = visibleTargetItems[0];
            if (!firstItem) {
              // Skip this iteration and continue with next logic
            } else {
              const firstIndex = targetItems.indexOf(firstItem);

              if (firstIndex !== -1) {
                if (moveType === "up") {
                  insertIndex = firstIndex;
                } else if (moveType === "below") {
                  insertIndex = firstIndex + 1;
                }
              }
            }
          }
        }

        // CRITICAL FIX: Check if we already have specific positioning from Rich Text/Canvas logic
        if (
          location.state.targetNodeType === "Rich Text" ||
          location.state.targetNodeType === "Canvas"
        ) {
          // Don't return early - continue with positioning logic
        }

        // Insert at the calculated position
        targetItems.splice(insertIndex, 0, placeholderItem);
      }

      updatedItems[targetContainerId] = targetItems;

      // For "into" moves, we still need to remove the item from the source
      // and add it to the target. Don't return early.
      if (moveType === "into") {
        // Continue processing to actually move the real item
      } else {
        return updatedItems;
      }
    } else if (!sourceContainerId || !targetContainerId) {
      console.error(
        "Source or target container ID is missing, cannot proceed with reorganization"
      );
      return updatedItems;
    }

    const isSourceSubstep = location.state.sourceSubstepIndex !== undefined;
    const sourceItems = updatedItems[sourceContainerId] || [];

    // For "into" moves, we need to find the actual video item to move
    if (moveType === "into" && normalizedNodeType === "video") {

      // For "into" moves, ensure we have valid source parameters
      if (!sourceContainerId) {
        return updatedItems;
      }


      // Find the video item in the source container
      let videoItem = sourceItems.find(
        (item) => item && (item.type === "video" || item.video_tree_node_id)
      );

      if (videoItem) {

        const itemIndex = sourceItems.indexOf(videoItem);
        if (itemIndex !== -1) {
          if (createCopy) {

            // For copy, create a deep copy without removing from source
            const videoItemCopy = JSON.parse(JSON.stringify(videoItem));

            // Generate new unique IDs
            const timestamp = Date.now();
            if (videoItemCopy.video_tree_node_id) {
              videoItemCopy.video_tree_node_id = `${videoItemCopy.video_tree_node_id}_copy_${timestamp}`;
            }
            if (videoItemCopy.rich_text_node_id) {
              videoItemCopy.rich_text_node_id = `${videoItemCopy.rich_text_node_id}_copy_${timestamp}`;
            }
            if (videoItemCopy.form_tree_node_id) {
              videoItemCopy.form_tree_node_id = `${videoItemCopy.form_tree_node_id}_copy_${timestamp}`;
            }
            if (videoItemCopy.attachment_tree_node_id) {
              videoItemCopy.attachment_tree_node_id = `${videoItemCopy.attachment_tree_node_id}_copy_${timestamp}`;
            }
            if (videoItemCopy.canvas_tree_node_id) {
              videoItemCopy.canvas_tree_node_id = `${videoItemCopy.canvas_tree_node_id}_copy_${timestamp}`;
            }


            // Use the copy for the target
            videoItem = videoItemCopy;
          } else {

            // For move, remove from source
            sourceItems.splice(itemIndex, 1);
            updatedItems[sourceContainerId] = sourceItems;
          }

          // Prepare item for target
          if (isTargetSubstep) {
            videoItem.substep_id_ref = targetContainerId;
            videoItem.sub_step_tree_node_id = targetContainerId;
          } else {
            delete videoItem.substep_id_ref;
            delete videoItem.sub_step_tree_node_id;
          }

          // Mark as moved item for visual highlighting
          videoItem.isMovedItem = true;

          // Add to target
          targetItems = updatedItems[targetContainerId] || [];
          targetItems.push(videoItem);
          updatedItems[targetContainerId] = targetItems;

          return updatedItems;
        }
      } else {

        // Try to find the video in other steps if it's not in the expected source container
        for (const [stepId, items] of Object.entries(updatedItems)) {
          let videoItem = items.find(
            (item) => item && (item.type === "video" || item.video_tree_node_id)
          );

          if (videoItem) {

            const itemIndex = items.indexOf(videoItem);
            if (itemIndex !== -1) {
              if (createCopy) {

                // For copy, create a deep copy without removing from source
                const videoItemCopy = JSON.parse(JSON.stringify(videoItem));

                // Generate new unique IDs
                const timestamp = Date.now();
                if (videoItemCopy.video_tree_node_id) {
                  videoItemCopy.video_tree_node_id = `${videoItemCopy.video_tree_node_id}_copy_${timestamp}`;
                }
                if (videoItemCopy.rich_text_node_id) {
                  videoItemCopy.rich_text_node_id = `${videoItemCopy.rich_text_node_id}_copy_${timestamp}`;
                }
                if (videoItemCopy.form_tree_node_id) {
                  videoItemCopy.form_tree_node_id = `${videoItemCopy.form_tree_node_id}_copy_${timestamp}`;
                }
                if (videoItemCopy.attachment_tree_node_id) {
                  videoItemCopy.attachment_tree_node_id = `${videoItemCopy.attachment_tree_node_id}_copy_${timestamp}`;
                }
                if (videoItemCopy.canvas_tree_node_id) {
                  videoItemCopy.canvas_tree_node_id = `${videoItemCopy.canvas_tree_node_id}_copy_${timestamp}`;
                }


                // Use the copy for the target
                videoItem = videoItemCopy;
              } else {

                // For move, remove from this step
                items.splice(itemIndex, 1);
                updatedItems[stepId] = items;
              }

              // Prepare item for target
              if (isTargetSubstep) {
                videoItem.substep_id_ref = targetContainerId;
                videoItem.sub_step_tree_node_id = targetContainerId;
              } else {
                delete videoItem.substep_id_ref;
                delete videoItem.sub_step_tree_node_id;
              }

              // Mark as moved item for visual highlighting
              videoItem.isMovedItem = true;

              // Add to target
              targetItems = updatedItems[targetContainerId] || [];

              // CRITICAL FIX: Sort targetItems by sibling_order to ensure correct positioning
              targetItems.sort((a, b) => {
                if (!a || !b) return 0;
                const orderA =
                  a.sibling_order || a.procedure_tree?.sibling_order;
                const orderB =
                  b.sibling_order || b.procedure_tree?.sibling_order;
                const orderCompare = compareSiblingOrders(orderA, orderB);
                if (orderCompare !== 0) return orderCompare;
                // Fallback: compare created_at
                const dateA = a.created_at ? new Date(a.created_at) : null;
                const dateB = b.created_at ? new Date(b.created_at) : null;
                if (dateA && dateB) return dateB - dateA;
                return 0;
              });

              targetItems.push(videoItem);
              updatedItems[targetContainerId] = targetItems;

              return updatedItems;
            }
          }
        }

      }
    }

    // Filter for visible items of matching type
    const visibleSourceItems = sourceItems.filter((item) => {
      if (!item) return false; // Skip null/undefined items

      const isMatch =
        (item.type === normalizedNodeType ||
          (normalizedNodeType === "video" && item.video_tree_node_id) ||
          (normalizedNodeType === "richText" && item.rich_text_node_id)) &&
        (isSourceSubstep ||
          (!item.substep_id_ref && !item.sub_step_tree_node_id));
      return isMatch;
    });


    // If there are too few items in source, try looking for any type
    if (visibleSourceItems.length <= sourceNodeIndex) {

      // Look for any visible item
      const allVisibleItems = sourceItems.filter(
        (item) =>
          item &&
          (isSourceSubstep ||
            (!item.substep_id_ref && !item.sub_step_tree_node_id))
      );


      // If we still don't have enough items, try looking in other steps
      if (sourceNodeIndex >= allVisibleItems.length) {

        // Try to find the item in the correct source step
        if (
          location.state.sourceStepIndex !== undefined &&
          sourceStepIndex !== undefined
        ) {
          const sourceSectionId =
            sortedSections[sourceSectionIndex]?.section_tree_node_id;
          const sourceSteps = stepsBySection[sourceSectionId] || [];

          // Get step ID from the correct index
          if (sourceStepIndex < sourceSteps.length) {
            const correctSourceStep = sourceSteps[sourceStepIndex];
            const correctSourceStepId = correctSourceStep.step_tree_node_id;
            if (
              correctSourceStepId &&
              correctSourceStepId !== sourceContainerId
            ) {

              // Get items from this step
              const correctSourceItems =
                updatedItems[correctSourceStepId] || [];
              logContainerContents(
                correctSourceStepId,
                correctSourceItems,
                "Correct Source Step"
              );

              // Filter for the right type, with flexible type matching
              const correctVisibleItems = correctSourceItems.filter(
                (item) =>
                  (item.type === normalizedNodeType ||
                    (normalizedNodeType === "video" &&
                      item.video_tree_node_id) ||
                    (normalizedNodeType === "richText" &&
                      item.rich_text_node_id)) &&
                  !item.substep_id_ref &&
                  !item.sub_step_tree_node_id
              );

              if (sourceNodeIndex < correctVisibleItems.length) {
                // Found the item in the correct source step
                let correctItemToMove = correctVisibleItems[sourceNodeIndex];
                const correctItemIndex =
                  correctSourceItems.indexOf(correctItemToMove);

                if (correctItemIndex !== -1) {

                  if (createCopy) {

                    // For copy, create a deep copy without removing from source
                    const correctItemToMoveCopy = JSON.parse(
                      JSON.stringify(correctItemToMove)
                    );

                    // Generate new unique IDs
                    const timestamp = Date.now();
                    if (correctItemToMoveCopy.video_tree_node_id) {
                      correctItemToMoveCopy.video_tree_node_id = `${correctItemToMoveCopy.video_tree_node_id}_copy_${timestamp}`;
                    }
                    if (correctItemToMoveCopy.rich_text_node_id) {
                      correctItemToMoveCopy.rich_text_node_id = `${correctItemToMoveCopy.rich_text_node_id}_copy_${timestamp}`;
                    }
                    if (correctItemToMoveCopy.form_tree_node_id) {
                      correctItemToMoveCopy.form_tree_node_id = `${correctItemToMoveCopy.form_tree_node_id}_copy_${timestamp}`;
                    }
                    if (correctItemToMoveCopy.attachment_tree_node_id) {
                      correctItemToMoveCopy.attachment_tree_node_id = `${correctItemToMoveCopy.attachment_tree_node_id}_copy_${timestamp}`;
                    }
                    if (correctItemToMoveCopy.canvas_tree_node_id) {
                      correctItemToMoveCopy.canvas_tree_node_id = `${correctItemToMoveCopy.canvas_tree_node_id}_copy_${timestamp}`;
                    }


                    // Use the copy for the target
                    correctItemToMove = correctItemToMoveCopy;
                  } else {

                    // For move, remove from source
                    correctSourceItems.splice(correctItemIndex, 1);
                    updatedItems[correctSourceStepId] = correctSourceItems;
                  }

                  // Prepare for target
                  if (isTargetSubstep) {
                    correctItemToMove.substep_id_ref = targetContainerId;
                    correctItemToMove.sub_step_tree_node_id = targetContainerId;
                  } else {
                    delete correctItemToMove.substep_id_ref;
                    delete correctItemToMove.sub_step_tree_node_id;
                  }

                  // Mark as moved item for visual highlighting
                  correctItemToMove.isMovedItem = true;

                  // Add to target
                  targetItems = updatedItems[targetContainerId] || [];

                  // CRITICAL FIX: Sort targetItems by sibling_order to ensure correct positioning
                  targetItems.sort((a, b) => {
                    if (!a || !b) return 0;
                    const orderA =
                      a.sibling_order || a.procedure_tree?.sibling_order;
                    const orderB =
                      b.sibling_order || b.procedure_tree?.sibling_order;
                    const orderCompare = compareSiblingOrders(orderA, orderB);
                    if (orderCompare !== 0) return orderCompare;
                    // Fallback: compare created_at
                    const dateA = a.created_at ? new Date(a.created_at) : null;
                    const dateB = b.created_at ? new Date(b.created_at) : null;
                    if (dateA && dateB) return dateB - dateA;
                    return 0;
                  });

                  if (moveType === "into") {
                    // For "into" moves, add to the end
                    targetItems.push(correctItemToMove);
                  } else {
                    // For "up" or "below" moves

                    // When moving above/below, we need to consider ALL items in the container, not just items of the same type
                    const visibleTargetItems = targetItems.filter((item) => {
                      const containerMatches = isTargetSubstep
                        ? item.sub_step_tree_node_id === targetContainerId
                        : !item.substep_id_ref && !item.sub_step_tree_node_id;
                      return containerMatches;
                    });


                    insertIndex = targetItems.length;

                    // Use the corrected targetNodeIndex from the move function
                    const correctedTargetNodeIndex =
                      location.state.targetNodeIndex !== undefined
                        ? location.state.targetNodeIndex
                        : targetNodeIndex;

                    if (
                      correctedTargetNodeIndex !== undefined &&
                      correctedTargetNodeIndex < visibleTargetItems.length
                    ) {
                      const targetItem =
                        visibleTargetItems[correctedTargetNodeIndex];
                      const targetItemIndex = targetItems.indexOf(targetItem);

                      if (targetItemIndex !== -1) {
                        insertIndex =
                          moveType === "up"
                            ? targetItemIndex
                            : targetItemIndex + 1;
                      }
                    } else {

                      // Try to find by global node number if available
                      const targetGlobalNumber =
                        location.state.targetNodeGlobalNumber;
                      if (targetGlobalNumber && visibleTargetItems.length > 0) {
                        // Find any item with matching global number or use first as fallback
                        const firstItem = visibleTargetItems[0];
                        if (!firstItem) {
                          // Skip this iteration and continue with next logic
                        } else {
                          const firstIndex = targetItems.indexOf(firstItem);

                          if (firstIndex !== -1) {
                            if (moveType === "up") {
                              insertIndex = firstIndex;
                            } else if (moveType === "below") {
                              insertIndex = firstIndex + 1;
                            }
                          }
                        }
                      }
                    }

                    // CRITICAL FIX: Check if we already have specific positioning from Rich Text/Canvas logic
                    if (
                      location.state.targetNodeType === "Rich Text" ||
                      location.state.targetNodeType === "Canvas"
                    ) {
                      // Don't return early - continue with positioning logic
                    }

                    // Enhanced positioning logic for better accuracy
                    // Skip if we already found the target in priority logic
                    if (
                      location.state.targetNodeType &&
                      !richTextTargetFound &&
                      !canvasTargetFound
                    ) {

                      // Check if we have expectedSiblingOrder from the move function
                      if (location.state.expectedSiblingOrder) {

                        // Find items with similar sibling order
                        const targetBySiblingOrder = targetItems.find(
                          (item) => {
                            if (!item) return false;
                            const itemSiblingOrder =
                              item.sibling_order ||
                              item.procedure_tree?.sibling_order;
                            return (
                              itemSiblingOrder &&
                              Math.abs(
                                parseInt(itemSiblingOrder, 10) -
                                  location.state.expectedSiblingOrder
                              ) <= 1
                            );
                          }
                        );

                        if (targetBySiblingOrder) {
                          const targetIndex =
                            targetItems.indexOf(targetBySiblingOrder);
                          if (targetIndex !== -1) {
                            insertIndex =
                              moveType === "up" ? targetIndex : targetIndex + 1;
                          }
                        }
                      }

                      // Look for the target item by its type and properties
                      const targetItemType =
                        location.state.targetNodeType.toLowerCase();
                      const targetItemId = location.state.targetNodeId;

                      if (targetItemId) {
                        // Try to find by ID first
                        const targetById = targetItems.find((item) => {
                          if (!item) return false;
                          const itemId =
                            item.video_tree_node_id ||
                            item.rich_text_node_id ||
                            item.form_tree_node_id ||
                            item.canvas_tree_node_id ||
                            item.attachment_tree_node_id;
                          return itemId === targetItemId;
                        });

                        if (targetById) {
                          const targetIndex = targetItems.indexOf(targetById);
                          if (targetIndex !== -1) {
                            insertIndex =
                              moveType === "up" ? targetIndex : targetIndex + 1;
                          }
                        }
                      }

                      // If still no match, try by type and global number
                      if (
                        insertIndex === targetItems.length &&
                        location.state.targetNodeGlobalNumber
                      ) {
                        const targetByType = targetItems.find((item) => {
                          if (!item) return false;
                          const itemType =
                            item.type ||
                            (item.video_tree_node_id
                              ? "video"
                              : item.rich_text_node_id
                              ? "richText"
                              : item.form_tree_node_id
                              ? "form"
                              : item.canvas_tree_node_id
                              ? "canvas"
                              : item.attachment_tree_node_id
                              ? "attachment"
                              : null);
                          return itemType === targetItemType;
                        });

                        if (targetByType) {
                          const targetIndex = targetItems.indexOf(targetByType);
                          if (targetIndex !== -1) {
                            insertIndex =
                              moveType === "up" ? targetIndex : targetIndex + 1;
                          }
                        }
                      }
                    }

                    // CRITICAL FIX: Canvas-specific positioning logic
                    // The issue is that Canvas nodes might be handled differently
                    // Skip if we already found the target
                    if (
                      insertIndex === targetItems.length &&
                      location.state.targetNodeType !== "Canvas" &&
                      location.state.targetNodeType !== "Rich Text" &&
                      !richTextTargetFound
                    ) {

                      // SPECIAL HANDLING FOR CANVAS TARGETS
                      if (location.state.targetNodeType === "Canvas") {
                      }

                      // For "move above" operations, we need to insert BEFORE the target item
                      // This preserves the order of other items
                      if (
                        moveType === "up" &&
                        location.state.targetNodeIndex !== undefined
                      ) {
                        // For "move above", insert BEFORE the target item
                        const targetIndex = Math.min(
                          location.state.targetNodeIndex,
                          visibleTargetItems.length - 1
                        );
                        if (targetIndex >= 0) {
                          const targetItem = visibleTargetItems[targetIndex];
                          const targetItemIndex =
                            targetItems.indexOf(targetItem);
                          if (targetItemIndex !== -1) {
                            insertIndex = targetItemIndex; // Insert BEFORE target (above)
                          }
                        }
                      } else if (
                        moveType === "below" &&
                        location.state.targetNodeIndex !== undefined
                      ) {
                        // For "move below", insert AFTER the target item
                        const targetIndex = Math.min(
                          location.state.targetNodeIndex,
                          visibleTargetItems.length - 1
                        );
                        if (targetIndex >= 0) {
                          const targetItem = visibleTargetItems[targetIndex];
                          const targetItemIndex =
                            targetItems.indexOf(targetItem);
                          if (targetItemIndex !== -1) {
                            insertIndex = targetItemIndex + 1; // Insert AFTER target (below)
                          }
                        }
                      }

                      // CRITICAL FIX: Ensure Rich Text and Canvas specific logic takes precedence
                      // Don't skip the main positioning logic - continue with it
                      if (
                        location.state.targetNodeType === "Rich Text" ||
                        location.state.targetNodeType === "Canvas"
                      ) {
                        // Continue with positioning logic instead of returning early
                      }

                      // ENHANCED CANVAS TARGET DETECTION
                      // Skip if we already found the target (Canvas or Rich Text target found in Priority 1)
                      if (
                        location.state.targetNodeType === "Canvas" &&
                        insertIndex === targetItems.length
                      ) {

                        // Try multiple strategies to find the Canvas target
                        let canvasTarget = null;
                        let canvasIndex = -1;

                        // Strategy 1: Find by Canvas tree node ID
                        if (location.state.targetNodeId) {
                          canvasTarget = targetItems.find(
                            (item) =>
                              item &&
                              item.canvas_tree_node_id ===
                                location.state.targetNodeId
                          );
                          if (canvasTarget) {
                            canvasIndex = targetItems.indexOf(canvasTarget);
                          }
                        }

                        // Strategy 2: Find by type and global number
                        if (
                          canvasIndex === -1 &&
                          location.state.targetNodeGlobalNumber
                        ) {
                          canvasTarget = targetItems.find(
                            (item) =>
                              item &&
                              (item.type === "canvas" ||
                                item.canvas_tree_node_id)
                          );
                          if (canvasTarget) {
                            canvasIndex = targetItems.indexOf(canvasTarget);
                          }
                        }

                        // Strategy 3: Find any Canvas item
                        if (canvasIndex === -1) {
                          canvasTarget = targetItems.find(
                            (item) =>
                              item &&
                              (item.type === "canvas" ||
                                item.canvas_tree_node_id)
                          );
                          if (canvasTarget) {
                            canvasIndex = targetItems.indexOf(canvasTarget);
                          }
                        }

                        if (canvasIndex !== -1) {

                          if (moveType === "up") {
                            insertIndex = canvasIndex; // Insert BEFORE Canvas
                          } else if (moveType === "below") {
                            insertIndex = canvasIndex + 1; // Insert AFTER Canvas
                          }

                          // CRITICAL FIX: Ensure the video is inserted at the correct position
                          // For "move below" operations, we need to insert AFTER the target Canvas
                          if (moveType === "below") {
                            // For "move below", we want to insert RIGHT AFTER the target Canvas
                            // This means inserting at the position immediately after the target
                            insertIndex = canvasIndex + 1;


                            // Log the expected result for debugging
                            targetItems.forEach((item, idx) => {
                            });

                            const beforeItems = targetItems.slice(
                              0,
                              insertIndex
                            );
                            const afterItems = targetItems.slice(insertIndex);

                          }

                          // CRITICAL FIX: Mark that we've found the Canvas target and set the correct position
                          // This prevents other positioning logic from overwriting our carefully calculated insertIndex
                          canvasTargetFound = true;
                        } else {
                        }
                      }
                    }

                    targetItems.splice(insertIndex, 0, correctItemToMove);
                  }

                  updatedItems[targetContainerId] = targetItems;
                  logContainerContents(
                    targetContainerId,
                    targetItems,
                    "Updated Target"
                  );

                  return updatedItems;
                }
              }
            }
          }
        }
      }

      if (sourceNodeIndex < allVisibleItems.length) {
        let itemToMove = allVisibleItems[sourceNodeIndex];

        // Continue with this item...
        const itemIndexInList = sourceItems.indexOf(itemToMove);
        if (itemIndexInList === -1) {
          console.error(`Item found in filtered list but not in main list`);
          return updatedItems;
        }

        if (createCopy) {

          // For copy, get the item without removing it from source
          itemToMove = sourceItems[itemIndexInList];
          if (!itemToMove) {
            console.error(
              `Failed to get item at source index ${itemIndexInList}.`
            );
            return updatedItems;
          }

          // Create a deep copy of the item with a new unique ID
          itemToMove = JSON.parse(JSON.stringify(itemToMove));

          // Generate new unique IDs based on item type
          const timestamp = Date.now();
          if (itemToMove.video_tree_node_id) {
            itemToMove.video_tree_node_id = `${itemToMove.video_tree_node_id}_copy_${timestamp}`;
          }
          if (itemToMove.rich_text_node_id) {
            itemToMove.rich_text_node_id = `${itemToMove.rich_text_node_id}_copy_${timestamp}`;
          }
          if (itemToMove.form_tree_node_id) {
            itemToMove.form_tree_node_id = `${itemToMove.form_tree_node_id}_copy_${timestamp}`;
          }
          if (itemToMove.attachment_tree_node_id) {
            itemToMove.attachment_tree_node_id = `${itemToMove.attachment_tree_node_id}_copy_${timestamp}`;
          }
          if (itemToMove.canvas_tree_node_id) {
            itemToMove.canvas_tree_node_id = `${itemToMove.canvas_tree_node_id}_copy_${timestamp}`;
          }

        } else {

          // For move, remove the item from source
          sourceItems.splice(itemIndexInList, 1);
          updatedItems[sourceContainerId] = sourceItems;
        }

        // Prepare item for target
        if (isTargetSubstep) {
          itemToMove.substep_id_ref = targetContainerId;
          itemToMove.sub_step_tree_node_id = targetContainerId;
        } else {
          delete itemToMove.substep_id_ref;
          delete itemToMove.sub_step_tree_node_id;
        }

        // Mark as moved item for visual highlighting
        itemToMove.isMovedItem = true;

        targetItems = updatedItems[targetContainerId] || [];

        // CRITICAL FIX: Sort targetItems by sibling_order to ensure correct positioning
        targetItems.sort((a, b) => {
          if (!a || !b) return 0;
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;
          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;
          // Fallback: compare created_at
          const dateA = a.created_at ? new Date(a.created_at) : null;
          const dateB = b.created_at ? new Date(b.created_at) : null;
          if (dateA && dateB) return dateB - dateA;
          return 0;
        });


        if (moveType === "into") {
          targetItems.push(itemToMove);
        } else {
          // For "up" or "below" moves, find the right position
          // When moving above/below, we need to consider ALL items in the container, not just items of the same type
          // This is because we want to position relative to the target item regardless of its type
          const visibleTargetItems = targetItems.filter((item) => {
            if (!item) return false; // Skip null/undefined items

            const containerMatches = isTargetSubstep
              ? item.sub_step_tree_node_id === targetContainerId
              : !item.substep_id_ref && !item.sub_step_tree_node_id;
            return containerMatches;
          });


          insertIndex = targetItems.length; // Default to end of list

          // CANVAS-SPECIFIC TARGET DETECTION (PRIORITY 1)
          if (location.state.targetNodeType === "Canvas") {

            // Initialize insertIndex for Canvas target detection
            insertIndex = targetItems.length; // Default to end of list

            // Try to find Canvas target by multiple strategies
            let canvasTarget = null;
            let canvasIndex = -1;

            // Strategy 1: Find by Canvas tree node ID (most precise)
            if (location.state.targetNodeId) {
              canvasTarget = targetItems.find(
                (item) =>
                  item &&
                  item.canvas_tree_node_id === location.state.targetNodeId
              );
              if (canvasTarget) {
                canvasIndex = targetItems.indexOf(canvasTarget);
              }
            }

            // Strategy 2: Find by global number (more precise than type)
            if (canvasIndex === -1 && location.state.targetNodeGlobalNumber) {
              // Find ALL Canvas items and check their global numbers
              const allCanvasItems = targetItems.filter(
                (item) =>
                  item && (item.type === "canvas" || item.canvas_tree_node_id)
              );



              // Find the specific Canvas with matching global number
              canvasTarget = allCanvasItems.find((item) => {
                const itemGlobalNumber =
                  item.global_node_number || item.globalNodeNumber;
                return (
                  itemGlobalNumber === location.state.targetNodeGlobalNumber
                );
              });

              if (canvasTarget) {
                canvasIndex = targetItems.indexOf(canvasTarget);
              }
            }

            // Strategy 3: Find by target node index if it's within bounds
            if (
              canvasIndex === -1 &&
              location.state.targetNodeIndex !== undefined
            ) {
              const targetIndex = location.state.targetNodeIndex;
              if (targetIndex < targetItems.length) {
                const itemAtIndex = targetItems[targetIndex];
                if (
                  itemAtIndex &&
                  (itemAtIndex.type === "canvas" ||
                    itemAtIndex.canvas_tree_node_id)
                ) {
                  canvasTarget = itemAtIndex;
                  canvasIndex = targetIndex;
                }
              }
            }

            // Strategy 4: Find any Canvas item as last resort
            if (canvasIndex === -1) {
              canvasTarget = targetItems.find(
                (item) =>
                  item && (item.type === "canvas" || item.canvas_tree_node_id)
              );
              if (canvasTarget) {
                canvasIndex = targetItems.indexOf(canvasTarget);
              }
            }

            if (canvasIndex !== -1) {

              if (moveType === "up") {
                insertIndex = canvasIndex; // Insert BEFORE Canvas
              } else if (moveType === "below") {
                insertIndex = canvasIndex + 1; // Insert AFTER Canvas
              }

              // Skip the regular positioning logic since we found the Canvas target

              // CRITICAL: Force the insertIndex to be correct and skip all other logic

              // CRITICAL FIX: Mark that we've found the Canvas target and set the correct position
              // This prevents other positioning logic from overwriting our carefully calculated insertIndex
              canvasTargetFound = true;
            } else {
            }
          }

          // RICH TEXT TARGET DETECTION (PRIORITY 1)

          if (
            location.state.targetNodeType === "Rich Text" ||
            location.state.targetNodeType === "richText" ||
            location.state.targetNodeType === "RichText" ||
            location.state.targetNodeType?.toLowerCase() === "rich text"
          ) {

            // Initialize insertIndex for Rich Text target detection
            insertIndex = targetItems.length; // Default to end of list

            // Try to find Rich Text target by multiple strategies
            let richTextTarget = null;
            let richTextIndex = -1;

            // Strategy 1: Find by Rich Text tree node ID (most precise)
            if (location.state.targetNodeId) {
              richTextTarget = targetItems.find(
                (item) =>
                  item && item.rich_text_node_id === location.state.targetNodeId
              );
              if (richTextTarget) {
                richTextIndex = targetItems.indexOf(richTextTarget);
              }
            }

            // Strategy 2: Find by global number (more precise than type)
            if (richTextIndex === -1 && location.state.targetNodeGlobalNumber) {

              // Find ALL Rich Text items and check their global numbers
              const allRichTextItems = targetItems.filter(
                (item) =>
                  item && (item.type === "richText" || item.rich_text_node_id)
              );



              // Debug: Check each Rich Text item individually
              allRichTextItems.forEach((item, idx) => {
                const itemGlobalNumber =
                  item.global_node_number || item.globalNodeNumber;
                const isMatch =
                  itemGlobalNumber === location.state.targetNodeGlobalNumber;
              });

              // Find the specific Rich Text with matching global number
              richTextTarget = allRichTextItems.find((item) => {
                const itemGlobalNumber =
                  item.global_node_number || item.globalNodeNumber;
                const isMatch =
                  itemGlobalNumber === location.state.targetNodeGlobalNumber;
                return isMatch;
              });

              if (richTextTarget) {
                richTextIndex = targetItems.indexOf(richTextTarget);
              } else {
              }
            }

            // Strategy 3: Find by target node index if it's within bounds
            if (
              richTextIndex === -1 &&
              location.state.targetNodeIndex !== undefined
            ) {
              const targetIndex = location.state.targetNodeIndex;
              if (targetIndex < targetItems.length) {
                const itemAtIndex = targetItems[targetIndex];
                if (
                  itemAtIndex &&
                  (itemAtIndex.type === "richText" ||
                    itemAtIndex.rich_text_node_id)
                ) {
                  richTextTarget = itemAtIndex;
                  richTextIndex = targetIndex;
                }
              }
            }

            // Strategy 4: Find any Rich Text item as last resort
            if (richTextIndex === -1) {
              richTextTarget = targetItems.find(
                (item) =>
                  item && (item.type === "richText" || item.rich_text_node_id)
              );
              if (richTextTarget) {
                richTextIndex = targetItems.indexOf(richTextTarget);
              }
            }

            if (richTextIndex !== -1) {

              if (moveType === "up") {
                insertIndex = richTextIndex; // Insert BEFORE Rich Text
              } else if (moveType === "below") {
                insertIndex = richTextIndex + 1; // Insert AFTER Rich Text
              }

              // Skip the regular positioning logic since we found the Rich Text target

              // CRITICAL: Force the insertIndex to be correct and skip all other logic

              // Additional debugging for positioning

              // CRITICAL FIX: Ensure the video is inserted at the correct position
              // For "move below" operations, we need to insert AFTER the target Rich Text
              if (moveType === "below") {
                // For "move below", we want to insert RIGHT AFTER the target Rich Text
                // This means inserting at the position immediately after the target
                insertIndex = richTextIndex + 1;


                // Log the expected result for debugging
                targetItems.forEach((item, idx) => {
                });

                const beforeItems = targetItems.slice(0, insertIndex);
                const afterItems = targetItems.slice(insertIndex);

              }

              // CRITICAL FIX: Mark that we've found the target and set the correct position
              // This prevents other positioning logic from overwriting our carefully calculated insertIndex
              richTextTargetFound = true;

              // CRITICAL DEBUG: Confirm the insertIndex is set correctly
            } else {
            }
          }

          // CRITICAL FIX: Corrected positioning logic for "move above" operations
          // For "move above", we need to insert BEFORE the target item to preserve order
          // Skip if we already found the Canvas or Rich Text target
          if (
            insertIndex === targetItems.length &&
            targetNodeIndex < visibleTargetItems.length &&
            location.state.targetNodeType !== "Canvas" && // Skip if Canvas target already found
            location.state.targetNodeType !== "Rich Text" && // Skip if Rich Text target already found
            !richTextTargetFound && // Skip if Rich Text target was found in priority logic
            !canvasTargetFound // Skip if Canvas target was found in priority logic
          ) {
            const targetItem = visibleTargetItems[targetNodeIndex];
            const targetItemIndex = targetItems.indexOf(targetItem);

            if (targetItemIndex !== -1) {
              if (moveType === "up") {
                // Insert BEFORE target (above) - this preserves the order of other items
                insertIndex = targetItemIndex;
              } else if (moveType === "below") {
                // Insert AFTER target (below) - this preserves the order of other items
                insertIndex = targetItemIndex + 1;
              }
            } else {
            }
          } else if (
            insertIndex === targetItems.length &&
            location.state.targetNodeType !== "Canvas" &&
            location.state.targetNodeType !== "Rich Text" &&
            !richTextTargetFound &&
            !canvasTargetFound
          ) {
            // Handle out of bounds target with corrected logic
            // Skip if we already found the Canvas target

            // Try using global node number if available
            const targetGlobalNumber = location.state.targetNodeGlobalNumber;
            if (targetGlobalNumber && visibleTargetItems.length > 0) {

              // FIRST: Try to find the actual target by global number
              const targetByGlobalNumber = visibleTargetItems.find((item) => {
                if (!item) return false;
                // Check if this item matches the target global number
                const itemGlobalNumber =
                  item.global_node_number || item.globalNodeNumber;
                return itemGlobalNumber === targetGlobalNumber;
              });

              if (targetByGlobalNumber) {
                const targetIndex = targetItems.indexOf(targetByGlobalNumber);
                if (targetIndex !== -1) {
                  if (moveType === "up") {
                    insertIndex = targetIndex; // Insert BEFORE target
                  } else if (moveType === "below") {
                    insertIndex = targetIndex + 1; // Insert AFTER target
                  }
                }
              } else {

                // Find by global number or use first item as fallback
                const firstItem = visibleTargetItems[0];
                if (!firstItem) {
                  // Skip this iteration and continue with next logic
                } else {
                  const firstIndex = targetItems.indexOf(firstItem);

                  if (firstIndex !== -1) {
                    if (moveType === "up") {
                      // For "move above", insert BEFORE first item to preserve order
                      insertIndex = firstIndex;
                    } else if (moveType === "below") {
                      // For "move below", insert AFTER first item
                      insertIndex = firstIndex + 1;
                    }
                  }
                }
              }
            } else {
            }
          }

          // ENHANCED CANVAS TARGET DETECTION (when target index is out of bounds)
          // Skip if we already found the Canvas target
          if (
            insertIndex === targetItems.length &&
            location.state.targetNodeType === "Canvas"
          ) {

            // Try multiple strategies to find the Canvas target
            let canvasTarget = null;
            let canvasIndex = -1;

            // Strategy 1: Find by Canvas tree node ID
            if (location.state.targetNodeId) {
              canvasTarget = targetItems.find(
                (item) =>
                  item &&
                  item.canvas_tree_node_id === location.state.targetNodeId
              );
              if (canvasTarget) {
                canvasIndex = targetItems.indexOf(canvasTarget);
              }
            }

            // Strategy 2: Find by type and global number
            if (canvasIndex === -1 && location.state.targetNodeGlobalNumber) {
              canvasTarget = targetItems.find(
                (item) =>
                  item && (item.type === "canvas" || item.canvas_tree_node_id)
              );
              if (canvasTarget) {
                canvasIndex = targetItems.indexOf(canvasTarget);
              }
            }

            // Strategy 3: Find any Canvas item
            if (canvasIndex === -1) {
              canvasTarget = targetItems.find(
                (item) =>
                  item && (item.type === "canvas" || item.canvas_tree_node_id)
              );
              if (canvasTarget) {
                canvasIndex = targetItems.indexOf(canvasTarget);
              }
            }

            if (canvasIndex !== -1) {

              if (moveType === "up") {
                insertIndex = canvasIndex; // Insert BEFORE Canvas
              } else if (moveType === "below") {
                insertIndex = canvasIndex + 1; // Insert AFTER Canvas
              }

              // CRITICAL FIX: Mark that we've found the Canvas target and set the correct position
              // This prevents other positioning logic from overwriting our carefully calculated insertIndex
              canvasTargetFound = true;
            } else {
            }
          }

          // Enhanced positioning logic for better accuracy
          // Skip if we already found the target
          if (
            location.state.targetNodeType &&
            location.state.targetNodeType !== "Canvas" && // Skip if Canvas target already found
            location.state.targetNodeType !== "Rich Text" && // Skip if Rich Text target already found
            !richTextTargetFound && // Skip if Rich Text target was found in priority logic
            !canvasTargetFound // Skip if Canvas target was found in priority logic
          ) {

            // Look for the target item by its type and properties
            const targetItemType = location.state.targetNodeType.toLowerCase();
            const targetItemId = location.state.targetNodeId;

            if (targetItemId) {
              // Try to find by ID first
              const targetById = targetItems.find((item) => {
                if (!item) return false;
                const itemId =
                  item.video_tree_node_id ||
                  item.rich_text_node_id ||
                  item.form_tree_node_id ||
                  item.canvas_tree_node_id ||
                  item.attachment_tree_node_id;
                return itemId === targetItemId;
              });

              if (targetById) {
                const targetIndex = targetItems.indexOf(targetById);
                if (targetIndex !== -1) {
                  insertIndex =
                    moveType === "up" ? targetIndex : targetIndex + 1;
                }
              }
            }

            // If still no match, try by type and global number
            if (
              insertIndex === targetItems.length &&
              location.state.targetNodeGlobalNumber
            ) {
              const targetByType = targetItems.find((item) => {
                if (!item) return false;
                const itemType =
                  item.type ||
                  (item.video_tree_node_id
                    ? "video"
                    : item.rich_text_node_id
                    ? "richText"
                    : item.form_tree_node_id
                    ? "form"
                    : item.canvas_tree_node_id
                    ? "canvas"
                    : item.attachment_tree_node_id
                    ? "attachment"
                    : null);
                return itemType === targetItemType;
              });

              if (targetByType) {
                const targetIndex = targetItems.indexOf(targetByType);
                if (targetIndex !== -1) {
                  insertIndex =
                    moveType === "up" ? targetIndex : targetIndex + 1;
                }
              }
            }
          }

          targetItems.splice(insertIndex, 0, itemToMove);
        }

        updatedItems[targetContainerId] = targetItems;
        return updatedItems;
      }
    }

    // Continue with normal processing if we have enough items
    if (sourceNodeIndex >= visibleSourceItems.length) {
      console.error(
        `Source node index ${sourceNodeIndex} out of bounds for ${normalizedNodeType} items (found ${visibleSourceItems.length})`
      );

      // If we have any items, use the last item as a fallback
      if (visibleSourceItems.length > 0) {
        const adjustedIndex = visibleSourceItems.length - 1;
        sourceNodeIndex = adjustedIndex;
      } else {
        return updatedItems;
      }
    }

    let itemToMove = visibleSourceItems[sourceNodeIndex];
    if (!itemToMove) {
      console.error(
        `Failed to find ${normalizedNodeType} item at index ${sourceNodeIndex}`
      );
      return updatedItems;
    }


    const itemIndexInList = sourceItems.indexOf(itemToMove);
    if (itemIndexInList === -1) {
      console.error(`Item found in filtered list but not in main list`);
      return updatedItems;
    }

    if (createCopy) {

      // For copy, get the item without removing it from source
      itemToMove = sourceItems[itemIndexInList];
      if (!itemToMove) {
        console.error(`Failed to get item at source index ${itemIndexInList}.`);
        return updatedItems;
      }

      // Create a deep copy of the item with a new unique ID
      itemToMove = JSON.parse(JSON.stringify(itemToMove));

      // Generate new unique IDs based on item type
      const timestamp = Date.now();
      if (itemToMove.video_tree_node_id) {
        itemToMove.video_tree_node_id = `${itemToMove.video_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.rich_text_node_id) {
        itemToMove.rich_text_node_id = `${itemToMove.rich_text_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.form_tree_node_id) {
        itemToMove.form_tree_node_id = `${itemToMove.form_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.attachment_tree_node_id) {
        itemToMove.attachment_tree_node_id = `${itemToMove.attachment_tree_node_id}_copy_${timestamp}`;
      }
      if (itemToMove.canvas_tree_node_id) {
        itemToMove.canvas_tree_node_id = `${itemToMove.canvas_tree_node_id}_copy_${timestamp}`;
      }

    } else {

      // For move, remove the item from source
      sourceItems.splice(itemIndexInList, 1);
      updatedItems[sourceContainerId] = sourceItems;
    }

    // Prepare item for target
    if (isTargetSubstep) {
      itemToMove.substep_id_ref = targetContainerId;
      itemToMove.sub_step_tree_node_id = targetContainerId;
    } else {
      delete itemToMove.substep_id_ref;
      delete itemToMove.sub_step_tree_node_id;
    }

    // Mark as moved item for visual highlighting
    itemToMove.isMovedItem = true;

    // Use the existing targetItems array if it exists, otherwise create a new one
    targetItems = updatedItems[targetContainerId] || [];

    // CRITICAL FIX: Sort targetItems by sibling_order to ensure correct positioning
    targetItems.sort((a, b) => {
      if (!a || !b) return 0;
      const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
      const orderB = b.sibling_order || b.procedure_tree?.sibling_order;
      const orderCompare = compareSiblingOrders(orderA, orderB);
      if (orderCompare !== 0) return orderCompare;
      // Fallback: compare created_at
      const dateA = a.created_at ? new Date(a.created_at) : null;
      const dateB = b.created_at ? new Date(b.created_at) : null;
      if (dateA && dateB) return dateB - dateA;
      return 0;
    });


    if (moveType === "into") {
      targetItems.push(itemToMove);
    } else {
      // For "up" or "below" moves, find the right position
      // When moving above/below, we need to consider ALL items in the container, not just items of the same type
      // This is because we want to position relative to the target item regardless of its type
      const visibleTargetItems = targetItems.filter((item) => {
        // Match container (step or substep)
        const containerMatches = isTargetSubstep
          ? item.sub_step_tree_node_id === targetContainerId
          : !item.substep_id_ref && !item.sub_step_tree_node_id;

        return containerMatches;
      });


      insertIndex = targetItems.length; // Default to end of list

      // If we have a target node index and enough items
      if (
        targetNodeIndex !== undefined &&
        targetNodeIndex < visibleTargetItems.length
      ) {
        const targetItem = visibleTargetItems[targetNodeIndex];
        const targetItemIndex = targetItems.indexOf(targetItem);

        if (targetItemIndex !== -1) {
          // Insert before (up) or after (below)
          if (moveType === "up") {
            insertIndex = targetItemIndex;
          } else if (moveType === "below") {
            insertIndex = targetItemIndex + 1;
          }
        } else {
        }
      } else {
        // Handle out of bounds target

        // Try using global node number if available
        const targetGlobalNumber = location.state.targetNodeGlobalNumber;
        if (targetGlobalNumber && visibleTargetItems.length > 0) {

          // Try to find an item with matching global number
          const matchingItem = visibleTargetItems.find(
            (item) =>
              item.globalNodeNumber === targetGlobalNumber ||
              (item.nodeIndex &&
                parseInt(item.nodeIndex) === parseInt(targetGlobalNumber))
          );

          if (matchingItem) {
            const matchIndex = targetItems.indexOf(matchingItem);
            if (matchIndex !== -1) {
              if (moveType === "up") {
                insertIndex = matchIndex;
              } else if (moveType === "below") {
                insertIndex = matchIndex + 1;
              }
            }
          } else {
            // If no match, use first item as fallback
            const firstItem = visibleTargetItems[0];
            if (!firstItem) {
              // Skip this iteration and continue with next logic
            } else {
              const firstIndex = targetItems.indexOf(firstItem);

              if (firstIndex !== -1) {
                if (moveType === "up") {
                  insertIndex = firstIndex;
                } else if (moveType === "below") {
                  insertIndex = firstIndex + 1;
                }
              }
            }
          }
        }
      }

      // CRITICAL FIX: Check if we already have specific positioning from Rich Text/Canvas logic
      if (
        location.state.targetNodeType === "Rich Text" ||
        location.state.targetNodeType === "Canvas"
      ) {
        // Don't return early - continue with positioning logic
      }

      // Enhanced positioning logic for better accuracy
      // If we still don't have a valid insert index, try to find the target by its actual properties
      // Skip if we already found the target in priority logic
      if (
        location.state.targetNodeType &&
        !richTextTargetFound &&
        !canvasTargetFound
      ) {

        // Look for the target item by its type and properties
        const targetItemType = location.state.targetNodeType.toLowerCase();
        const targetItemId = location.state.targetNodeId;

        if (targetItemId) {
          // Try to find by ID first
          const targetById = targetItems.find((item) => {
            if (!item) return false;
            const itemId =
              item.video_tree_node_id ||
              item.rich_text_node_id ||
              item.form_tree_node_id ||
              item.canvas_tree_node_id ||
              item.attachment_tree_node_id;
            return itemId === targetItemId;
          });

          if (targetById) {
            const targetIndex = targetItems.indexOf(targetById);
            if (targetIndex !== -1) {
              insertIndex = moveType === "up" ? targetIndex : targetIndex + 1;
            }
          }
        }

        // If still no match, try by type and global number
        if (
          insertIndex === targetItems.length &&
          location.state.targetNodeGlobalNumber
        ) {
          const targetByType = targetItems.find((item) => {
            if (!item) return false;
            const itemType =
              item.type ||
              (item.video_tree_node_id
                ? "video"
                : item.rich_text_node_id
                ? "richText"
                : item.form_tree_node_id
                ? "form"
                : item.canvas_tree_node_id
                ? "canvas"
                : item.attachment_tree_node_id
                ? "attachment"
                : null);
            return itemType === targetItemType;
          });

          if (targetByType) {
            const targetIndex = targetItems.indexOf(targetByType);
            if (targetIndex !== -1) {
              insertIndex = moveType === "up" ? targetIndex : targetIndex + 1;
            }
          }
        }
      }

      // CRITICAL DEBUG: Log the final insertIndex before splicing

      // Show the current order of items before insertion
      targetItems.forEach((item, idx) => {
      });


      // Insert at the calculated position
      targetItems.splice(insertIndex, 0, itemToMove);

      // CRITICAL DEBUG: Show the final state of targetItems after insertion
      targetItems.forEach((item, idx) => {
      });
    }

    // Update target container
    updatedItems[targetContainerId] = targetItems;
    return updatedItems;
  };

  // Combine all content items for preview
  const allContentItems = {};

  Object.keys(updatedSteps).forEach((sectionId) => {
    updatedSteps[sectionId].forEach((step) => {
      const stepId = step.step_tree_node_id;

      // Debug step IDs
      if (
        stepId === location.state.sourceStepId ||
        stepId === location.state.targetStepId
      ) {
      }

      // STEP-level content
      const stepContent = [
        ...(richTexts[stepId] || []).map((item) => ({
          ...item,
          type: "richText",
        })),
        ...(forms[stepId] || []).map((item) => ({
          ...item,
          type: "form",
        })),
        ...(attachments[stepId] || []).map((item) => ({
          ...item,
          type: "attachment",
        })),
        ...(canvases[stepId] || []).map((item) => ({
          ...item,
          type: "canvas",
        })),
        ...(videos[stepId] || []).map((item) => ({
          ...item,
          type: "video",
        })),
      ]
        .filter(
          (item) => item && !item.substep_id_ref && !item.sub_step_tree_node_id
        )
        .sort((a, b) => {
          // Skip null items
          if (!a || !b) return 0;

          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = a.created_at ? new Date(a.created_at) : null;
          const dateB = b.created_at ? new Date(b.created_at) : null;

          if (dateA && dateB) {
            return dateB - dateA; // latest comes first
          }

          return 0; // If dates are not available, maintain order
        });

      allContentItems[stepId] = stepContent;

      // Debug content for source and target steps
      if (
        stepId === location.state.sourceStepId ||
        stepId === location.state.targetStepId
      ) {
      }

      // SUBSTEP-level content
      const substeps = substepsByStep[stepId] || [];
      substeps.forEach((substep) => {
        const substepId = substep.sub_step_tree_node_id;

        allContentItems[substepId] = [
          ...(richTexts[substepId] || []).map((item) => ({
            ...item,
            type: "richText",
          })),
          ...(forms[substepId] || []).map((item) => ({
            ...item,
            type: "form",
          })),
          ...(attachments[substepId] || []).map((item) => ({
            ...item,
            type: "attachment",
          })),
          ...(canvases[substepId] || []).map((item) => ({
            ...item,
            type: "canvas",
          })),
          ...(videos[substepId] || []).map((item) => ({
            ...item,
            type: "video",
          })),
        ]
          .filter((item) => item) // Remove any null/undefined items
          .sort((a, b) => {
            // Skip null items
            if (!a || !b) return 0;

            const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
            const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

            const orderCompare = compareSiblingOrders(orderA, orderB);
            if (orderCompare !== 0) return orderCompare;

            // Fallback: compare created_at
            const dateA = a.created_at ? new Date(a.created_at) : null;
            const dateB = b.created_at ? new Date(b.created_at) : null;

            if (dateA && dateB) {
              return dateB - dateA; // latest comes first
            }

            return 0; // If dates are not available, maintain order
          });
      });
    });
  });

  const updatedAllContentItems = getReorganizedContentItems(
    allContentItems,
    location.state.sourceStepId,
    location.state.targetStepId,
    location.state.sourceNodeIndex,
    location.state.targetNodeIndex,
    moveType,
    location.state.sourceNodeType?.toLowerCase() || "video"
  );


  // Debug specific step content
  if (location.state.sourceStepId) {
  }
  if (location.state.targetStepId) {
  }
  const updatedAttachments = {};
  const updatedRichTexts = {};
  const updatedForms = {};
  const updatedVideos = {};
  const updatedCanvases = {};

  Object.entries(updatedAllContentItems).forEach(([containerId, items]) => {
    updatedAttachments[containerId] = items.filter(
      (i) => i && i.type === "attachment"
    );
    updatedRichTexts[containerId] = items.filter(
      (i) => i && i.type === "richText"
    );
    updatedForms[containerId] = items.filter((i) => i && i.type === "form");
    updatedVideos[containerId] = items.filter((i) => i && i.type === "video");
    updatedCanvases[containerId] = items.filter(
      (i) => i && i.type === "canvas"
    );
  });

  // Debug video arrays
  if (location.state.targetStepId) {
  }

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              {createCopy ? "Copying video..." : "Moving video..."}
            </div>
          </div>
        </div>
      )}

      <ProcedureMoveAppBar
        selectedView={selectedView}
        showBackButton={false}
        setSelectedView={handleViewChange}
        title={
          createCopy
            ? "Please Confirm the Changes"
            : "Please Confirm the Changes"
        }
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 0",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            {/* Hide procedure checkbox */}
            <span
              style={{ fontSize: "20px", marginLeft: "18px", fontWeight: 600 }}
            >
              {type} {partNumber}
            </span>
          </label>

          {/* Description */}
          {/* <span style={{ marginLeft: "2px", marginTop: "5px", color: "#666" }}>
            Description: {description}
          </span> */}
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>{location.state.status}</span>
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        <div style={{ marginTop: "20px" }}>
          {sections.map((section, index) => {
            return (
              <div
                key={section.section_tree_node_id}
                style={{
                  margin: "20px 0",
                  clear: "both",
                }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    clear: "both",
                  }}
                >
                  <h2 style={{ margin: 0 }}>Section {index + 1}</h2>
                </label>
                <hr />
                <hr />
                <div style={{ clear: "both" }}>{section.section_name}</div>
                <div style={{ clear: "both" }}>{section.short_description}</div>

                {/* Steps for this section */}
                {(updated[section.section_tree_node_id] || []).map(
                  (step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = previewSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc + (updated[s.section_tree_node_id]?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    const currentRichTextCounter = richTextCounter;

                    richTextsCounter[stepId] = currentRichTextCounter;

                    // Choose which data to display based on selectedView
                    const displayedRichTexts =
                      selectedView === "new" ? updatedRichTexts : richTexts;
                    const displayedForms =
                      selectedView === "new" ? updatedForms : forms;
                    const displayedAttachments =
                      selectedView === "new" ? updatedAttachments : attachments;
                    const displayedCanvases =
                      selectedView === "new" ? updatedCanvases : canvases;
                    const displayedVideos =
                      selectedView === "new" ? updatedVideos : videos;

                    // Use the selected content arrays for preview
                    const combinedItems =
                      selectedView === "new"
                        ? updatedAllContentItems[stepId] || []
                        : allContentItems[stepId] || []; // Filter out substeps or unwanted items (same as your current filter)// Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );

                    // Store the section index to use in the inner loop
                    const currentSectionIndex = index;

                    // filteredItems.sort((a, b) => {
                    //   const orderA =
                    //     a.sibling_order || a.procedure_tree?.sibling_order;
                    //   const orderB =
                    //     b.sibling_order || b.procedure_tree?.sibling_order;

                    //   const orderCompare = compareSiblingOrders(orderA, orderB);
                    //   if (orderCompare !== 0) return orderCompare;

                    //   // Fallback: compare created_at
                    //   const dateA = new Date(a.created_at);
                    //   const dateB = new Date(b.created_at);
                    //   return dateB - dateA; // latest comes first
                    // });

                    return (
                      <div
                        key={stepId}
                        style={{ marginTop: "20px", clear: "both" }}
                      >
                        <label>
                          <HeadingWithTreePath
                            title={`Step ${globalStepNumber}`}
                            treePathParams={{
                              sectionIndex: currentSectionIndex,
                              stepIndex: globalStepNumber - 1,
                              substepIndex: undefined,
                              nodeType: undefined,
                              nodeIndex: undefined,
                            }}
                          >
                            {location.state.movingStep &&
                              steps &&
                              steps.length > 0 &&
                              (step.step_tree_node_id ===
                                steps[0].step_tree_node_id ||
                                (section.section_tree_node_id ===
                                  sortedSections[targetSectionIndex]
                                    ?.section_tree_node_id &&
                                  ((moveType === "up" &&
                                    stepIndex === targetStepIndex) ||
                                    (moveType === "below" &&
                                      stepIndex === targetStepIndex + 1) ||
                                    (moveType === "into" &&
                                      stepIndex ===
                                        (
                                          updated[
                                            section.section_tree_node_id
                                          ] || []
                                        ).length -
                                          1)))) && (
                                <span
                                  style={{
                                    fontSize: "20px",
                                    color: "#007bff",
                                    marginLeft: "10px",
                                    fontStyle: "italic",
                                  }}
                                >
                                  {/* {step.step_tree_node_id ===
                                steps[0].step_tree_node_id
                                  ? "(Moving)"
                                  : "(New Position)"} */}
                                </span>
                              )}
                          </HeadingWithTreePath>
                        </label>
                        <hr />
                        <p style={{ clear: "both", whiteSpace: 'pre-wrap' }}>
                          {step.short_description || ""}
                        </p>
                        <p style={{ clear: "both" }}>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty != 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}&nbsp;
                                  </>
                                );
                              })}
                          </p>
                        </p>

                        <h4 style={{ clear: "both" }}>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table" style={{ clear: "both" }}>
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr style={{ clear: "both" }}>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />{" "}
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item, index) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <HeadingWithTreePath
                                  title={`Rich Text ${globalRichTextNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "richText",
                                    nodeIndex: globalRichTextNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.rich_text_node_id ||
                                    `richText-${globalRichTextNumber}`
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      fontWeight: "600",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  {item.category_data && (
                                    <div
                                      style={{
                                        marginLeft: "4px",
                                        marginTop: "10px",
                                        clear: "both",
                                      }}
                                    >
                                      {item.category_data.category_name}
                                    </div>
                                  )}
                                  <div
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginTop: "-6px",
                                        clear: "both",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              // Find the local index of this video within the current step
                              const videoItems = filteredItems.filter(
                                (item) => item.type === "video"
                              );
                              const localVideoIndex = videoItems.findIndex(
                                (video) =>
                                  video.video_tree_node_id ===
                                  item.video_tree_node_id
                              );

                              // Debug video rendering
                              const label = (
                                <HeadingWithTreePath
                                  title={`Video ${globalVideoNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "video",
                                    nodeIndex: globalVideoNumber - 1,
                                  }}
                                />
                              );

                              // Check if this is the source item being moved
                              const isSourceItem =
                                selectedView === "original" &&
                                location.state.sourceStepId === stepId &&
                                location.state.sourceNodeIndex === index &&
                                location.state.sourceNodeType?.toLowerCase() ===
                                  "video";

                              return (
                                <div
                                  key={
                                    item.video_tree_node_id ||
                                    `video-${globalVideoNumber}`
                                  }
                                  style={{
                                    marginTop: "20px",
                                    position: "relative",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {label}
                                    {/* Add indicator for moved item */}
                                    {(selectedView === "new" &&
                                      item.isMovedItem) ||
                                    isSourceItem ? (
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          color: "#007bff",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        {/* {isSourceItem ? "(Source)" : "(Moving)"} */}
                                      </span>
                                    ) : null}
                                  </label>

                                  <div style={{}}>
                                    {renderVideo(item)}

                                    <div>{item.video_url}</div>

                                    <div>{item.short_description}</div>
                                  </div>

                                  {/* Add an insertion point indicator for "below" moves */}
                                  {selectedView === "new" &&
                                    location.state.targetStepId === stepId &&
                                    location.state.targetNodeIndex === index &&
                                    location.state.targetNodeType === "Video" &&
                                    moveType === "below" && (
                                      <div
                                        style={{
                                          height: "2px",
                                          backgroundColor: "#007bff",
                                          marginTop: "10px",
                                          position: "relative",
                                        }}
                                      >
                                        <span
                                          style={{
                                            position: "absolute",
                                            bottom: "-15px",
                                            right: "0",
                                            fontSize: "20px",
                                            color: "#007bff",
                                            fontStyle: "italic",
                                          }}
                                        >
                                          Insert Below
                                        </span>
                                      </div>
                                    )}
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Form ${globalFormNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "form",
                                    nodeIndex: globalFormNumber - 1,
                                  }}
                                />
                              );
                              // render form block here
                              return (
                                <div
                                  key={
                                    item.form_tree_node_id ||
                                    `form-${globalFormNumber}`
                                  }
                                  style={{ clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      fontSize: "20px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Canvas ${globalCanvasNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "canvas",
                                    nodeIndex: globalCanvasNumber - 1,
                                  }}
                                />
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div
                                  key={
                                    item.canvas_tree_node_id ||
                                    `canvas-${globalCanvasNumber}`
                                  }
                                  style={{ marginTop: "40px", clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      fontWeight: "600",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div style={{ clear: "both" }}>
                                    {item.short_description}
                                  </div>

                                  {/* Display all pages vertically */}
                                  <CanvasDisplay pages={pages} />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              const label = (
                                <HeadingWithTreePath
                                  title={`Attachment ${globalAttachmentNumber}`}
                                  treePathParams={{
                                    sectionIndex: currentSectionIndex,
                                    stepIndex: globalStepNumber - 1,
                                    substepIndex: undefined,
                                    nodeType: "attachment",
                                    nodeIndex: globalAttachmentNumber - 1,
                                  }}
                                />
                              );

                              return (
                                <div
                                  key={
                                    item.attachment_tree_node_id ||
                                    `attachment-${globalAttachmentNumber}`
                                  }
                                  style={{ clear: "both" }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                      fontSize: "20px",
                                      fontWeight: "600",
                                      clear: "both",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div>{item.short_description}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div
                                      key={`attachment-${globalAttachmentNumber}-${i}`}
                                      style={{
                                        marginLeft: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(updatedSubstepsByStep[stepId] || []).map(
                          (substep, substepIndex) => {
                            const substepId = substep.sub_step_tree_node_id;
                            // Choose content based on view mode
                            const combinedItems =
                              selectedView === "new"
                                ? updatedAllContentItems[substepId] || []
                                : allContentItems[substepId] || [];

                            const filteredItems = combinedItems;

                            // Global step number calculation based on the updated steps data
                            const stepsBeforeThisOne =
                              previewSections
                                .slice(0, index)
                                .reduce((sectionAcc, s) => {
                                  const steps =
                                    updated[s.section_tree_node_id] || [];
                                  return sectionAcc + steps.length;
                                }, 0) + stepIndex;

                            const globalStepNumber = stepsBeforeThisOne + 1;

                            // Final substep label like Substep 5A
                            const substepLetter = String.fromCharCode(
                              65 + substepIndex
                            ); // A, B, C, ...

                            const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                            return (
                              <div
                                key={substepId}
                                style={{ marginTop: "20px", clear: "both" }}
                              >
                                <div>
                                  <HeadingWithTreePath
                                    title={globalSubstepLabel}
                                    treePathParams={{
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: substepIndex,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    }}
                                  />
                                  <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                                </div>

                                {/* Substep Rich Texts */}
                                {filteredItems.map((item, index) => {
                                  switch (item.type) {
                                    case "richText": {
                                      const globalRichTextNumber =
                                        richTextCounter++; // ✅ use then increment
                                      // render richText block here
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Rich Text ${globalRichTextNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "richText",
                                            nodeIndex: globalRichTextNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.rich_text_node_id ||
                                            `richText-${globalRichTextNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              fontSize: "20px",
                                              fontWeight: "600",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          {item.category_data && (
                                            <div
                                              style={{
                                                marginLeft: "4px",
                                                marginTop: "10px",
                                                clear: "both",
                                              }}
                                            >
                                              {item.category_data.category_name}
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              fontSize: "20px",
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                              clear: "both",
                                            }}
                                          >
                                            <div
                                              style={{
                                                marginTop: "-6px",
                                                clear: "both",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.rich_text_content,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "video": {
                                      const globalVideoNumber = videoCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Video ${globalVideoNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "video",
                                            nodeIndex: globalVideoNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.video_tree_node_id ||
                                            `video-${globalVideoNumber}`
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              fontSize: "20px",
                                              fontWeight: "600",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          {renderVideo(item)}
                                          <div>{item.video_url}</div>

                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }

                                    case "form": {
                                      const globalFormNumber = formCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Form ${globalFormNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "form",
                                            nodeIndex: globalFormNumber - 1,
                                          }}
                                        />
                                      );
                                      // render form block here
                                      return (
                                        <div
                                          key={
                                            item.form_tree_node_id ||
                                            `form-${globalFormNumber}`
                                          }
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                              fontSize: "20px",
                                              fontWeight: "600",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div style={{ clear: "both" }}>
                                            {item.short_description}
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "canvas": {
                                      const pages = getPages(item);

                                      const globalCanvasNumber =
                                        canvasCounter++; // ✅ use then increment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Canvas ${globalCanvasNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "canvas",
                                            nodeIndex: globalCanvasNumber - 1,
                                          }}
                                        />
                                      );
                                      const shapes = item.shapes || [];

                                      return (
                                        <div
                                          key={
                                            item.canvas_tree_node_id ||
                                            `canvas-${globalCanvasNumber}`
                                          }
                                          style={{
                                            marginTop: "40px",
                                            clear: "both",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              fontSize: "20px",
                                              fontWeight: "600",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div>{item.short_description}</div>

                                          {/* Display all pages vertically */}
                                          <CanvasDisplay pages={pages} />
                                        </div>
                                      );
                                    }
                                    case "attachment": {
                                      const attachmentList =
                                        item.attachments || [];
                                      if (attachmentList.length === 0)
                                        return null;

                                      //  const globalAttachmentNumber =
                                      //           attachmentCounter++; // ✅ use then increment
                                      const globalAttachmentNumber =
                                        attachmentCounter++; // ✅ Increment here per attachment
                                      const label = (
                                        <HeadingWithTreePath
                                          title={`Attachment ${globalAttachmentNumber}`}
                                          treePathParams={{
                                            sectionIndex: currentSectionIndex,
                                            stepIndex: globalStepNumber - 1,
                                            substepIndex: substepIndex,
                                            nodeType: "attachment",
                                            nodeIndex:
                                              globalAttachmentNumber - 1,
                                          }}
                                        />
                                      );

                                      return (
                                        <div
                                          key={
                                            item.attachment_tree_node_id ||
                                            `substep-attachment-${globalAttachmentNumber}`
                                          }
                                          style={{ clear: "both" }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                              fontSize: "20px",
                                              fontWeight: "600",
                                              clear: "both",
                                            }}
                                          >
                                            {label}
                                          </label>
                                          <div style={{ clear: "both" }}>
                                            {item.short_description}
                                          </div>
                                          {attachmentList.map(
                                            (attachment, i) => (
                                              <div
                                                key={`${
                                                  item.attachment_tree_node_id ||
                                                  `substep-attachment-${globalAttachmentNumber}`
                                                }-${i}`}
                                                style={{
                                                  marginLeft: "20px",
                                                  clear: "both",
                                                }}
                                              >
                                                {renderPreview(attachment)}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    }
                                    default:
                                      return null;
                                  }
                                })}
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* Remove old loader position */}
      {/* {isLoading && <Loader text="Saving step..." />} */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "20px",
                  color: "#333333",
                }}
              >
                {createCopy
                  ? generateConfirmMoveMessage({
                      locationState: location.state,
                      nodeType: "Video",
                      moveType,
                      sourceStepIndex,
                      targetStepIndex,
                      targetSectionData,
                      sourceSectionIndex,
                      targetSectionIndex,
                    }).replace("Confirm Move", "Confirm Copy")
                  : generateConfirmMoveMessage({
                      locationState: location.state,
                      nodeType: "Video",
                      moveType,
                      sourceStepIndex,
                      targetStepIndex,
                      targetSectionData,
                      sourceSectionIndex,
                      targetSectionIndex,
                    })}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#666",
                }}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "14px" }}>
                For {type} {partNumber} - Rev {revision}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment<span className="required">*</span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              {isModalLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="loader-spinner"
                    style={{
                      border: "4px solid #f3f3f3",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      animation: "spin 1s linear infinite",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span>Processing...</span>
                </div>
              )}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                }}
                disabled={isModalLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                  opacity: isModalLoading ? 0.7 : 1,
                }}
                disabled={isModalLoading}
              >
                {isModalLoading
                  ? createCopy
                    ? "Copying..."
                    : "Moving..."
                  : createCopy
                  ? "Copy"
                  : "Move"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcedureVideoMovePreview;
